import { useEffect } from 'react';
import { useFlow } from '../utilities/useFlow';

export const ThemeSwitcher: React.FC = () => {
  const flow = useFlow();

  useEffect(() => {
    const bodyElement = document.body;

    if (flow === 'Keepr') {
      bodyElement.classList.add('keepr-theme');
    } else {
      bodyElement.classList.remove('keepr-theme');
    }
  }, [flow]);

  return null;
};
